import { useCompanySetting } from "Components/CompanySetting/hooks/useCompanySetting";
import { useIsInternalAdmin } from "Components/Members/hooks/useIsInternalAdmin";
import Modal from "Components/Modal/Modal";
import { useApp } from "Providers/AppProvider";
import React, { FC } from "react";
import WorkingHoursForm from "./WorkingHoursForm";
import { useWorkingHoursModal } from "./hooks/useWorkingHoursModal";

const WorkingHoursModal: FC = () => {
	const hasWorkingHours = useCompanySetting(
		(state) => !!state.item?.workingHours
	);
	const isModalOpen = useWorkingHoursModal((state) => state.isOpen);
	const isInternalAdmin = useIsInternalAdmin();
	const { isNative } = useApp();

	if (!isModalOpen) return null;
	if (isNative) return null;
	if (!isInternalAdmin) return null;

	return (
		<Modal
			modalController={useWorkingHoursModal.getState()}
			isCloseDisabled={!hasWorkingHours}
			size="md"
		>
			<WorkingHoursForm
				isCloseDisabled={!hasWorkingHours}
				close={useWorkingHoursModal.getState().close}
			/>
		</Modal>
	);
};

export default WorkingHoursModal;
